import { apiClient, signApiRequest } from ".";
import { useMutation } from "@tanstack/react-query";
import { CustomerCredentials } from "../ui/customerDataStore";
import { captureException } from "@sentry/react";
interface Payload {
  credentials: CustomerCredentials;
  insurances: string[];
  signature: string;
}

export const createOpenPolicy = async ({
  credentials,
  insurances,
  signature,
}: Payload) => {
  const signedRequest = await signApiRequest(
    "POST",
    `${import.meta.env.VITE_API_URL}/transfer/transfer-policy`,
    credentials,
    { "content-type": "application/json" },
    {
      fid: credentials.identityId,
      insurances: insurances,
      signature: signature,
    },
  );

  const response = await apiClient(signedRequest);

  return response.data;
};

export const useCreateOpenPolicy = () =>
  useMutation({
    onError: (error) => {
      captureException(error, {
        tags: {
          operation: "createOpenPolicy",
          errorType: error.name || "UnknownError",
        },
        extra: {
          apiEndpoint: "/transfer/transfer-policy",
        },
        level: "error",
      });
    },
    mutationFn: ({ credentials, insurances, signature }: Payload) =>
      createOpenPolicy({
        credentials,
        insurances,
        signature,
      }),
  });
